import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { Spin, Row, Col, Button, Select, Tooltip, Modal, Drawer, message } from 'antd';
import { UnorderedListOutlined } from '@ant-design/icons';
import { find, isEmpty } from 'lodash';
import SplitPane from 'react-split-pane';

import {
    setSelectedYear,
    loadComplianceReports,
    clearSelectedDetailReport,
    loadReportDetails
} from '../actions';
import * as constants from '../constants';

import ReportForm from './ReportForm';

import uistate from '../../uistate';
import common from '../../../common';
import core from '../../core';
import currentuser from '../../currentuser';
import globalappstate from '../../globalappstate';
import workflow from '../../workflow';

const { AgGridWithState } = core;
const { RendererBoolean, RendererStatus } = common;
const { LogbookGrid } = workflow;

class ComplianceReportsGrid extends Component {

    state = {
        selectedIdReport: 0,
        initialloading: true,
        editFormVisible: false,
        currentEditEntity: {},
        showLogDrawer: false,
    }

    constructor(props) {
        super(props);

        this.gird = null;
        this.setGridRef = element => {
            this.gird = element;
        };
        this.deselectAll = () => {
            // Focus the text input using the raw DOM API
            if (this.gird) this.gird.deselectAll();
        };
    }

    async UNSAFE_componentWillMount() {
        if (this.props.compliancereports.length == 0) {
            this.props.clearSelectedDetailReport();
            await this.props.loadComplianceReports(this.props.selectedYear);
            this.setState({
                initialloading: false,
            });
        } else {
            this.setState({
                initialloading: false,
            });
        }
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'ComplianceReportsGrid', key);
    }
    nrFormatter = (params) => {
        if (params.value) {
            return Number(params.value).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        } else {
            return ''
        }
    }

    getGridCols = () => {
        let cols = [
            { key: "company", width: 70, headerName: this.label("Company"), field: "company", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter", rowGroup: true, hide: true },
            { key: "statusText", headerName: this.label("Status"), field: "statusText", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, width: 80, minWidth: 80 },
            { key: "number", width: 120, minWidth: 120, maxWidth: 120, headerName: this.label("Number"), field: "number", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "type", width: 70, headerName: this.label("Type"), field: "type", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true },
            { key: "personnelNumber", headerName: this.label("PersonnelNumber"), field: "personnelNumber", sortable: true, filter: false, enableRowGroup: false, suppressHeaderMenuButton: true, width: 100, minWidth: 100, maxWidth: 100, filter: "agTextColumnFilter" },
            { key: "fullname", width: 70, headerName: this.label("Username"), field: "fullname", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "supervisor", width: 70, headerName: this.label("Supervisor"), field: "supervisor", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "amount", width: 100, minWidth: 100, maxWidth: 100, headerName: this.label("Amount"), field: "amount", sortable: true, filter: false, enableRowGroup: false, suppressHeaderMenuButton: true, filter: "agTextColumnFilter", type: 'rightAligned', valueFormatter: this.nrFormatter },
        ]

        return cols;
    }

    onGridReady = (params) => {
        this.gridApi = params.api;


        params.api.setGridOption('rowData', this.props.compliancereports);
    };

    calculateCurrentUserMutateRights = () => {
        let result = false;
        return result;
    }

    //#region Grid/Button handlers
    handleChangeYear = async (value) => {
        this.props.setSelectedYear(value);
        this.gridApi.setGridOption('loading', true);
        await this.props.loadComplianceReports(value);
        this.gridApi.setGridOption('rowData', this.props.compliancereports);
        this.gridApi.setGridOption('loading', false);
    }

    onSelect = async (dataitem) => {
        let details = await this.props.loadReportDetails(dataitem.idReport);
        this.setState({
            editFormVisible: true,
            currentEditEntity: details,
        });
    }
    refreshClicked = async () => {
        this.gridApi.setGridOption('loading', true);
        await this.props.loadComplianceReports(this.props.selectedYear);
        this.gridApi.setGridOption('rowData', this.props.compliancereports);
        this.gridApi.setGridOption('loading', false);
    }

    //#endregion

    showLogDrawer = () => {
        this.setState({
            showLogDrawer: true,
        });
    };
    onCloseLogDrawer = () => {
        this.setState({
            showLogDrawer: false,
        });
    };

    //#region Form handlers

    handleCancelForm = (e) => {
        this.setState({
            editFormVisible: false,
            currentEditEntity: {},
        });
        this.deselectAll();
    }

    //#endregion

    render() {
        const userHasMutateRights = this.calculateCurrentUserMutateRights();

        const loading = this.state.initialloading;
        const menuHeight = 45
        const gridHeight = this.props.contentHeight - menuHeight;
        const columnDefinitions = this.getGridCols();

        return (
            <div className='reports'>
                <Row className='main-toolbar' style={{ height: menuHeight }} justify='start' align='middle' gutter={8}>
                    <Col span={24} >
                        <span className='module-title'>{this.label("ComplianceReports")}</span>
                        <span style={{ margin: 5, marginLeft: 25 }}>{this.label("Year")}</span>
                        <Select onChange={this.handleChangeYear} value={this.props.selectedYear}>
                            {
                                this.props.picklists.years ? this.props.picklists.years.map(o => <Select.Option key={o.id} value={o.id}>{o.name}</Select.Option>) : null
                            }
                        </Select>
                    </Col>
                </Row>
                {loading ? (
                    <div className="loader-content" >
                        <Spin size="large" />
                        <p>{this.label("Loading")}</p>
                    </div>
                ) : (
                    <div>
                        <AgGridWithState gridkey='compliancereports' ref={this.setGridRef} height={gridHeight} ShowGroupPanel={true}
                            getRowNodeId={(data) => { return data.idReport; }}
                            onReady={this.onGridReady}
                            lang={this.props.curLanguage}
                            autoGroupColumnDef={{ headerName: this.label("Company"), field: 'company', minWidth: 200 }}
                            onItemDoubleClicked={this.onSelect}
                            columnDefinitions={columnDefinitions}
                            onRefresh={this.refreshClicked}
                            labels={this.props.labels}
                            frameworkComponents={{
                                'rendererBoolean': RendererBoolean, 'rendererStatus': RendererStatus
                            }}
                        >
                        </AgGridWithState>
                        <Modal title={<span>{this.label("ReportModalTitle")}
                            {this.state.currentEditEntity.workflowInstanceId &&
                                <Button size='small' onClick={this.showLogDrawer} style={{ marginLeft: 30 }} >
                                    <UnorderedListOutlined />{this.label("ReportWorkflowLog")}
                                </Button>
                            }</span>}
                            width='60%' destroyOnHidden={true}
                            open={this.state.editFormVisible}
                            footer={null}
                            onCancel={this.handleCancelForm}
                        >
                            <ReportForm datacontext={this.state.currentEditEntity} onCancel={this.handleCancelForm} readOnly={true} contentheight={this.props.contentHeight} />
                        </Modal>
                    </div>

                )}
                <Drawer destroyOnHidden={true} width='50%' title={this.label("ReportWorkflowLog")} placement="left" closable={true} onClose={this.onCloseLogDrawer} open={this.state.showLogDrawer} mask={true} maskClosable={true}>
                    <LogbookGrid workflowInstanceId={this.state.currentEditEntity.workflowInstanceId} />
                </Drawer>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        compliancereports: state[constants.NAME].compliancereports,
        selectedYear: state[constants.NAME].selectedYear,
        contentHeight: state[uistate.constants.NAME].contentheight,
        labels: uistate.selectors.uiLabels(state),
        curLanguage: uistate.selectors.curLanguage(state),
        currentuser: state[currentuser.constants.NAME],
        picklists: globalappstate.selectors.allPicklists(state),
    };
}

export default connect(mapStateToProps,
    {
        setSelectedYear,
        loadComplianceReports,
        loadReportDetails,
        clearSelectedDetailReport,
    })(ComplianceReportsGrid);